<template>
<div class="columns is-multiline">
  <div class="column is-one-quarter" v-for="tag in tags" :key="tag">
    <router-link :to="{name: 'JobsList', query: {q: tag}}" class="tag" :title="tag"><i class="dot is-primary"></i><span>{{tag}}</span></router-link>
  </div>
</div>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .tags {
    .tag {
      width: 20%;
      justify-content: left;

      span {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/jobs/job-tags.vue